import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import LandingPage from './components/LandingPage';
import PrivateRoute from './components/PrivateRoute';
import { ScrollbarStyle } from './components/ScrollBar';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <ScrollbarStyle />
      <Router>
        <AuthProvider>
                <Routes>
                  <Route path="/login" element={<LandingPage />} />
                  <Route 
                    path="/" 
                    element={
                      <PrivateRoute>
                        <Dashboard />
                      </PrivateRoute>
                    } 
                  />
                </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
